import { Form } from 'antd';
import moment from 'moment';
import React, { useCallback, useEffect } from 'react';
import DateFormItem from '@aims/shared/components/DateFormItem';
import TaskSomethingForm from '../../tasks/ViewTaskModal/TaskSomethingForm';

function ChangeStartEndDateInnerModalA10({
  adoption,
  saving,
  handleFinish,
  onCancel,
}) {
  const [form] = Form.useForm();
  useEffect(() => {
    if (adoption) {
      form.setFieldsValue({
        startDate: adoption.startDate,
        endDate: adoption.endDate,
      });
    }
  }, [adoption, form]);
  const _handleFinish = useCallback(
    (_values) => {
      const { startDate, endDate, ...values } = _values;
      handleFinish({
        startDate: startDate ? moment(startDate) : null,
        endDate: endDate ? moment(endDate) : null,
        ...values,
      });
    },
    [handleFinish],
  );
  return (
    <TaskSomethingForm
      form={form}
      onFinish={_handleFinish}
      onCancel={onCancel}
      saving={saving}
      title="Change Start/End Date"
    >
      <DateFormItem label="Start Date" name="startDate" rules={[]} />
      <DateFormItem label="End Date" name="endDate" rules={[]} />
    </TaskSomethingForm>
  );
}

export default ChangeStartEndDateInnerModalA10;
